export default __webpack_public_path__ + "static/media/teachers.77f9fc68.png";